var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "social-container" }, [
    _c(
      "div",
      {
        staticClass: "box",
        on: {
          click: function ($event) {
            return _vm.handleClick("wechat")
          },
        },
      },
      [
        _c(
          "span",
          { staticClass: "container", style: { backgroundColor: "#6ba2d6" } },
          [
            _c("i", {
              staticClass: "iconfont icon-weixin",
              attrs: { "icon-class": "wechat" },
            }),
          ]
        ),
        _c("p", { staticClass: "title" }, [_vm._v("微信")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "box",
        on: {
          click: function ($event) {
            return _vm.handleClick("tencent")
          },
        },
      },
      [
        _c(
          "span",
          { staticClass: "container", style: { backgroundColor: "#8dc349" } },
          [
            _c("i", {
              staticClass: "iconfont icon-qq",
              attrs: { "icon-class": "qq" },
            }),
          ]
        ),
        _c("p", { staticClass: "title" }, [_vm._v("QQ")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "box",
        on: {
          click: function ($event) {
            return _vm.handleClick("gitee")
          },
        },
      },
      [
        _c(
          "span",
          { staticClass: "container", style: { backgroundColor: "#bf3030" } },
          [
            _c("i", {
              staticClass: "iconfont icon-logo_gitee_icon",
              attrs: { "icon-class": "qq" },
            }),
          ]
        ),
        _c("p", { staticClass: "title" }, [_vm._v("Gitee")]),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "box",
        on: {
          click: function ($event) {
            return _vm.handleClick("osc")
          },
        },
      },
      [
        _c(
          "span",
          { staticClass: "container", style: { backgroundColor: "#007B25" } },
          [
            _c("i", {
              staticClass: "iconfont icon-OSChina_logo_",
              attrs: { "icon-class": "qq" },
            }),
          ]
        ),
        _c("p", { staticClass: "title" }, [_vm._v("开源中国")]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }